<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/157mo8C/tc-custom/9781439672860.jpg?1705026246074" alt="This image is the cover for the book Strange New England"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Strange New England
      </h1>
      <p class="bookDescription body article font2">
        <p>New England boasts some of the strangest characters and stories that ever graced a region. From ghosts blessing a marriage to a clairvoyant who raised the dead, mysterious happenings abound. There is the simple grave of the mysterious and anonymous "XYZ" and the extravagant monument built for a pauper. One man may have actually found the elixir of immortality, while another woman left her whole fortune to a spirit she met via a Ouija board. Stories of the Melon Heads, the Leather Man and the Old Coot of Mount Greylock have fascinated New Englanders for years. Join Tom D'Agostino and Arlene Nicholson as they unveil the mysteries and oddities of this unique region.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas D'Agostino, Arlene Nicholson
      </h2>
      
      <p class="authorDescription body article">Thomas D'Agostino and his wife, Arlene Nicholson, have been extensively studying and investigating paranormal accounts for more than thirty-eight years, with more than 1,400 investigations to their credit. Tom and Arlene are ardent researchers of New England history, haunts, legends and folklore. Creators of fourteen books, together they have penned and captured on film the best haunts and history New England has to offer. Tom and Arlene's interviews and paranormal experiences have appeared in numerous newspapers, magazines and other periodicals throughout New England and beyond in regard to their books and comprehensive work in the paranormal field. Tom has contributed to various other books and publications and has appeared on many television and radio shows, as well as documentaries on the subject of the paranormal. Arlene is a professional photographer with a degree in photography. Tom is a graduate of Rhode Island College with a degree in political science. He is a professional teacher and musician. Tom builds his own musical instruments, many from the Medieval and Renaissance periods, that are used in his profession.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7dca2e1b